import DOMPurify from "dompurify";
import { useState } from "react";

const BlogTextShortener = ({fullText, words}) => {
    const [isExpanded,setIsExpanded]=useState(false);
    const fullTextArray = fullText.split(' ');
    const shortText = `${fullText.split(' ').slice(0, words).join(' ')}`;

    let html = isExpanded ? fullText : shortText;
    html = html
    .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
    .replace(/_(.*?)_/g, '<em>$1</em>')
    .replace(/~(.*?)~/g, '<mark>$1</mark>')
    .replace(/-(.*?)-/g, '<del>$1</del>');

    html = DOMPurify.sanitize(html);


    return ( 
        <div style={{display:"inline-block"}}>
            <pre dangerouslySetInnerHTML={{__html:html}}/>
            {fullTextArray && fullTextArray.length > words && (
                      <button onClick={()=>setIsExpanded(prev => !prev)}
                            style={{backgroundColor:"transparent",
                                    color:"#000000",
                                    cursor:"pointer",
                                    border:"none",
                                    fontWeight:"bolder"
                            }}>
                                {isExpanded ? 'Read Less' : '. . . Read More'}
                      </button>
            )}
        </div>
     );
}
export default BlogTextShortener;